import router from '@/router'
import store from '@/store'

const initialize = async () => {

  let settings = await store.dispatch('getSettings');

  document.title = settings.data.app.event_short + ' - Planner';
  store.commit('setSettings', settings.data);
  store.commit('setLanguage', settings.data.app.initial_language);

  let key = localStorage.getItem('x-api-key') || null;

  if (key && (
    !Object.keys(store.getters.authorized).length ||
    !Object.keys(store.getters.routes).length
  )) {

    const [wordings, authorized, routes, user /*, filters, columns, fields */] = await Promise.all([
      store.dispatch('getWordings'),
      store.dispatch('getAuthorized'),
      store.dispatch('getRoutes'),
      store.dispatch('getUser'),
    ]);

    store.commit('setProgress', false);
    store.commit('setWordings', wordings.data);
    store.commit('setAuthorized', authorized.data);
    store.commit('setRoutes', routes.data);
    store.commit('setUser', user.data);

    router.addRoute({
      path: '*',
      redirect: routes.data.start
    });

    if (window.location.hash.replace('#/', '') === '') {
      router.push(routes.data.start);
    }

  } else {

    const wordings = await store.dispatch('getWordings');
    store.commit('setProgress', false);
    store.commit('setWordings', wordings.data);
  }
}

export default initialize